import React from 'react'

import BlogCard from '@components/Content/BlogCard/BlogCard'
import NewsCard from '@components/Content/BlogCard/NewsCard'
import Button from '@components/Content/Button/Button'

import { wpButtonType } from '@contracts/acf/button'
import { wpTestimonialsCardDataType } from '@contracts/pages/testimonialSingle'
import { wpPostCardsType } from '@contracts/wp/wpPosts'

import * as styles from './BlogCardGrid.module.scss'

interface Props {
	data: wpTestimonialsCardDataType | wpPostCardsType
	hasNextPage: boolean
	nextPageLink: string
	isNews?: boolean
	clean?: boolean
}

const BlogCardGrid: React.FunctionComponent<Props> = (props) => {
	const buttonData: wpButtonType = {
		buttonType: 'internal',
		label: 'Show More',
		internalLink: {
			uri: props.nextPageLink,
		},
		externalLink: null,
	}

	const gridStyles = [styles.grid]

	if (props.clean) {
		gridStyles.push(styles.clean)
	}

	return (
		<>
			<ul className={gridStyles.join(' ')}>
				{props.data.map((card) => {
					return <li key={card.uri}>{props.isNews ? <NewsCard data={card} /> : <BlogCard data={card} />}</li>
				})}
			</ul>

			{props.hasNextPage ? <Button data={buttonData} className={styles.button} /> : null}
		</>
	)
}

export default BlogCardGrid
